/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import MobileSidebar from "../InitialPage/Sidebar/MobileSidebar";
import { pagesRoute, publicRoutes } from "./router.link";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../feature-module/loader/loader";
import ProtectiveRoutes from "./ProtectiveRoutes";
import { chatLoader } from "../util/widgetLoader";
import FilterBar from "../feature-module/Filter";

const AllRoutes = () => {
  const location = useLocation();

  // langHandler logic is adjusted to avoid overriding language in localStorage
  const langHandler = () => {
    let token = localStorage.getItem("access_token");
    let userId = localStorage.getItem("userId");
    const doc = document.getElementById("root");
    
    // Handle visibility of the root element for signin route
    if (location.pathname === "/signin") {
      if (doc) {
        doc.style.display = "none";
      }
      return;
    } else {
      if (doc) {
        doc.style.display = "block";
      }
    }

    // If user is authenticated, call chatLoader
    if (token && userId) {
      chatLoader();
    }
  };

  // Set language on the first load or if it's not in localStorage
  useEffect(() => {
    const lang = localStorage.getItem("lang");
    if (!lang) {
      localStorage.setItem("lang", "en"); // Default to 'en' if not set
    }
    langHandler();
  }, [location]);

  const data = useSelector((state) => state.toggle_header);

  const HeaderLayout = () => (
    <div className={`main-wrapper ${data ? "header-collapse" : ""}`}>
      <Header />
      <div className="layout-main-wrapper">
        <div className="desktop-sidebar">
          <Sidebar />
        </div>
        <div className="mobile-sidebar">
          <MobileSidebar />
        </div>
        <div className="outlet-container">
          <Outlet />
        </div>
      </div>
      <Loader />
    </div>
  );

  const Authpages = () => (
    <div className={data ? "header-collapse" : ""}>
      <Outlet />
      <Loader />
    </div>
  );

  return (
    <div className="main-router-wrapper">
      <Routes>
        <Route path={"/"} element={<HeaderLayout />}>
          {publicRoutes.map((route, id) => (
            <Route
              path={route.path}
              element={<ProtectiveRoutes>{route.element}</ProtectiveRoutes>}
              key={id}
            />
          ))}
        </Route>

        <Route path={"/"} element={<Authpages />}>
          {pagesRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
      </Routes>
    </div>
  );
};

export default AllRoutes;
